import * as React from 'react'
import createSvgIcon from '../createSvgIcon'

export default createSvgIcon(
  <>
    <path d='M2 6C2 4.9 2.9 4 4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6ZM20 6H4V8H20V6ZM4 18H20V10H4V18Z' />
    <path d='M6 14H8V16H6V14Z' />
    <path d='M10 14H14V16H10V14Z' />
  </>,
  'CreditCard'
)
